import { Button as MantineButton, type ButtonPropss as MantineButtonPropss } from '@mantine/core'

export interface ButtonProps extends MantineButtonPropss {
  label: string
  onClick: () => void
}

export function Button({ label, onClick, ...rest }: Readonly<ButtonProps>) {
  return (
    <MantineButton {...rest} onClick={onClick}>
      {label}
    </MantineButton>
  )
}
